import React from "react";
import type { Status } from "../constants";

const StatusIcon: React.FC<{ status: Status }> = ({ status }) => {
  if (status === "pass")
    return (
      <span className="w-6 h-6 rounded-full bg-primary text-white flex items-center justify-center shrink-0">
        <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
        </svg>
      </span>
    );
  if (status === "fail")
    return (
      <span className="w-6 h-6 rounded-full bg-red-500 text-white flex items-center justify-center shrink-0">
        <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </span>
    );
  if (status === "running")
    return (
      <span className="w-6 h-6 rounded-full border-2 border-primary border-t-transparent animate-spin shrink-0" />
    );
  return <span className="w-6 h-6 rounded-full border-2 border-gray-300 shrink-0" />;
};

export default StatusIcon;
